import React from "react";

function BotResponseLayout({ children, actionProvider }) {
  const buttonStyle = {
    padding: "10px 15px",
    borderRadius: "8px",
    border: "none",
    backgroundColor: "rgb(0, 89, 164)",
    color: "#fff",
    fontSize: "16px",
    cursor: "pointer",
    transition: "background-color 0.3s, transform 0.2s",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  };

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e5e7eb",
        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
        borderRadius: "12px",
        padding: "16px",
        width: "100%",
        fontFamily: "sans-serif",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      <div style={{ flex: 1, marginTop: '12pxu' }}>{children}</div>

      <button
        onClick={actionProvider.handleShowMenu}
        style={buttonStyle}
        onMouseEnter={(e) =>
          (e.currentTarget.style.backgroundColor = "rgb(0, 100, 200)")
        }
        onMouseLeave={(e) =>
          (e.currentTarget.style.backgroundColor = "rgb(0, 89, 164)")
        }
      >
        Show Main Menu
      </button>
    </div>
  );
}

export default BotResponseLayout;
